import type { ImgHTMLAttributes } from 'react'
import postgresLogo from './postgresql-logo.png'

/**
 * PostgreSQL elephant ("Slonik") logo — official mark rendered from a
 * bundled PNG asset.
 */
export const PostgresIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={postgresLogo} alt="" aria-hidden="true" {...props} />
)
